/* oxlint-disable typescript/no-explicit-any -- schema library requires flexible any types */
/* oxlint-disable typescript/no-unsafe-member-access -- schema library uses any types throughout */
import { BaseSchema } from '../core/base-schema'
import type { OptionalSchema, NullableSchema } from '../core/base-schema'
import type * as errors from '../core/errors'
import * as types from '../core/types'
import type { DefaultSchema } from './wrappers'
import { _default as makeDefault } from './wrappers'

export interface BytesSchemaDef extends types.SchemaTypeDef {
  type: 'bytes'
}

export interface BytesSchemaInternals extends types.SchemaInternals<
  Uint8Array,
  Uint8Array
> {
  def: BytesSchemaDef
}

export interface BytesSchema extends types.Schema<
  Uint8Array,
  Uint8Array,
  BytesSchemaInternals
> {
  optional(): OptionalSchema<this>
  nullable(): NullableSchema<this>
  default(defaultValue: Uint8Array | (() => Uint8Array)): DefaultSchema<this>
  meta(metadata: Record<string, any>): this
  parse(data: unknown, params?: types.ParseContext): Uint8Array
  safeParse(
    data: unknown,
    params?: types.ParseContext,
  ):
    | { success: true; data: Uint8Array }
    | { success: false; error: errors.SchemaError }
}

export const BytesSchema = types.$constructor<BytesSchema>(
  'BytesSchema',
  (inst, def: BytesSchemaDef) => {
    BaseSchema.init(inst, def)

    inst._zod.parse = (payload, _ctx) => {
      if (payload.value instanceof Uint8Array) return payload

      payload.issues.push({
        code: 'invalid_type',
        expected: 'Uint8Array',
        input: payload.value,
        inst,
      })
      return payload
    }

    inst.default = (defaultValue: Uint8Array | (() => Uint8Array)) => {
      return makeDefault(inst, defaultValue)
    }
  },
)

export function bytes(): BytesSchema {
  return new BytesSchema({
    type: 'bytes',
    proto: {
      scalar: { type: 'bytes', wireType: 'length-delimited' },
    },
  })
}
